var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgTermsOfUse(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.685.77H2.503C1.121.77 0 1.878 0 3.246v22.28c0 1.367 1.12 2.476 2.503 2.476h16.182c1.383 0 2.503-1.109 2.503-2.476V3.245c0-1.368-1.12-2.476-2.503-2.476z",
    fill: "#E6A273"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.711 3.328H5.808c-1.588 0-2.876 1.273-2.876 2.844v18.12c0 1.57 1.288 2.844 2.876 2.844H16.71c1.588 0 2.876-1.273 2.876-2.844V6.172c0-1.57-1.288-2.844-2.876-2.844z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.044 2.398H5.14c-1.588 0-2.875 1.274-2.875 2.844v18.12c0 1.571 1.287 2.844 2.875 2.844h10.904c1.588 0 2.875-1.273 2.875-2.844V5.242c0-1.57-1.287-2.844-2.875-2.844z",
    fill: "#FAFEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46 24.136L5.885 21.6a1.167 1.167 0 01-.346-.826 1.157 1.157 0 01.346-.826 1.182 1.182 0 01.836-.342 1.193 1.193 0 01.835.342l1.581 1.564a.813.813 0 001.129 0l4.295-4.272a1.177 1.177 0 01.833-.342 1.188 1.188 0 01.833.342 1.163 1.163 0 01.346.824 1.153 1.153 0 01-.346.824l-5.286 5.248a1.765 1.765 0 01-2.48 0z",
    fill: "#45E6B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.76 6.05H5.428a.825.825 0 00-.829.82v.253c0 .453.372.82.83.82H15.76c.458 0 .829-.367.829-.82V6.87a.825.825 0 00-.83-.82zM15.76 9.695H5.428a.825.825 0 00-.829.82v.252c0 .453.372.82.83.82H15.76c.458 0 .829-.367.829-.82v-.252a.825.825 0 00-.83-.82zM15.76 13.34H5.428a.825.825 0 00-.829.82v.252c0 .453.372.82.83.82H15.76c.458 0 .829-.367.829-.82v-.252a.825.825 0 00-.83-.82z",
    fill: "#CEE9F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.949 4.85H8.574c-.457 0-.895-.18-1.218-.5a1.695 1.695 0 01-.505-1.204V.77h8.82v2.376c0 .451-.18.885-.504 1.204-.323.32-.761.5-1.218.5z",
    fill: "#000",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.217 4.496H8.012c-.48 0-.94-.188-1.279-.524a1.778 1.778 0 01-.529-1.264V.872a.871.871 0 01.26-.615A.89.89 0 017.085 0h7.07a.89.89 0 01.621.257.871.871 0 01.26.615v1.836a1.771 1.771 0 01-.534 1.269 1.808 1.808 0 01-1.286.519z",
    fill: "#FFD580"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.49 15.368a24.667 24.667 0 01-5.355 8.4.373.373 0 01-.635-.236c-.16-3.342.373-6.68 1.565-9.812l2.305-5.456.846-2L24.48.904c.128-.31.373-.557.682-.692.31-.135.66-.147.977-.032l1.019.4c.312.118.567.349.712.647.145.297.17.638.068.953l-1.86 5.512-.7 2.068-1.888 5.608z",
    fill: "#99A5EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.773 9.901l-2.658 7.008a1.186 1.186 0 01-.666-.61 1.162 1.162 0 01-.033-.898l2.107-5.556a.448.448 0 00-.267-.576l-.631-.232-.247.724-4.008-1.488.846-2 4.67 1.728c.372.138.672.415.838.77.166.356.183.762.049 1.13z",
    fill: "#FFD580"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}
export default SvgTermsOfUse;